import { Injectable } from '@angular/core';
import { ToastInfo } from '@interfaces/toast-info';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  toasts: ToastInfo[] = [];

  constructor(private translate: TranslateService) {}

  showSuccessMessage(header: string, body = '') {
    this.translate.get(header).subscribe((translatedHeader: string) => {
      this.toasts.push({
        header: translatedHeader,
        body,
        className: 'bg-success text-light toast',
      });
    });
  }

  showInfoMessage(header: string, body = '', delay = 5000) {
    this.translate.get(header).subscribe((translatedHeader: string) => {
      this.toasts.push({
        header: translatedHeader,
        body,
        className: 'bg-info text-light toast',
        delay,
      });
    });
  }

  showInfoMessageWithErorrMessage(headerKey: string, errorText = '') {
    this.translate.get(headerKey).subscribe((translatedHeader: string) => {
      this.toasts.push({
        header: `${translatedHeader}: ${errorText}`,
        body: '',
        className: 'bg-info text-light toast',
      });
    });
  }

  getToasts(): ToastInfo[] {
    return this.toasts;
  }

  removeToasts(): void {
    this.toasts = [];
  }

  remove(toast: ToastInfo) {
    this.toasts = this.toasts.filter((t) => t !== toast);
  }
}
